// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_headerContent__cERXW {
  max-height: 90%; }

.styles_feed__Q95SB {
  max-height: 100%; }
  .styles_feed__Q95SB > div {
    height: 90%;
    margin: 0rem 0.5rem; }

.styles_container__r-RE3 {
  height: 100vh;
  width: 75vw;
  position: absolute;
  right: 0rem;
  top: 0rem;
  overflow: hidden;
  padding: 1rem;
  overflow: scroll; }
  .styles_container__r-RE3 > .styles_cardsContainer__c76W8 {
    display: grid;
    height: 90vh;
    width: 75vw;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-row-gap: 1rem;
    grid-column-gap: 1rem;
    overflow: scroll; }
    .styles_container__r-RE3 > .styles_cardsContainer__c76W8 > div {
      border-color: unset;
      box-shadow: 0px 0px 10px #8080801a;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      max-height: 40vh; }
  .styles_container__r-RE3 > div {
    overflow: hidden; }

.styles_entriesButton__A4zu8 {
  max-height: 5rem; }

.styles_dedicatedTimeFeedContainer__1sRJO > div {
  min-height: 18rem;
  max-height: 27rem;
  margin: 0.5rem 0.5rem; }

.styles_dedicatedTimeFeedContainer__1sRJO > button {
  max-height: 10rem;
  width: -webkit-fill-available;
  margin: 0.5rem 0.5rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/booths/components/screens/BoothScreen/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAe,EAAA;;AAGjB;EACE,gBAAgB,EAAA;EADlB;IAGI,WAAW;IACX,mBAAmB,EAAA;;AAIvB;EAoBE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gBAAgB,EAAA;EA3BlB;IAEI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,8BAA8B;IAC9B,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB,EAAA;IATpB;MAWM,mBAAmB;MACnB,kCCdY;MDeZ,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,gBAAgB,EAAA;EAjBtB;IA6BI,gBAAgB,EAAA;;AAOpB;EACE,gBAAgB,EAAA;;AAGlB;EAEM,iBAAiB;EACjB,iBAAiB;EACjB,qBACJ,EAAA;;AALF;EAOM,iBAAiB;EACjB,6BAA6B;EAC7B,qBAEJ,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.headerContent {\n  max-height: 90%;\n}\n\n.feed {\n  max-height: 100%;\n  & > div {\n    height: 90%;\n    margin: 0rem 0.5rem;\n  }\n}\n\n.container {\n  & > .cardsContainer {\n    display: grid;\n    height: 90vh;\n    width: 75vw;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr 1fr;\n    grid-row-gap: 1rem;\n    grid-column-gap: 1rem;\n    overflow: scroll;\n    & > div {\n      border-color: unset;\n      box-shadow: 0px 0px 10px $grey10;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      max-height: 40vh;\n    }\n  }\n  height: 100vh;\n  width: 75vw;\n  position: absolute;\n  right: 0rem;\n  top: 0rem;\n  overflow: hidden;\n  padding: 1rem;\n  overflow: scroll;\n  & > div {\n    overflow: hidden;\n  }\n\n\n}\n\n\n.entriesButton {\n  max-height: 5rem;\n}\n\n.dedicatedTimeFeedContainer { \n  & > div {\n      min-height: 18rem;\n      max-height: 27rem;\n      margin: 0.5rem 0.5rem\n  }\n  & > button {\n      max-height: 10rem;\n      width: -webkit-fill-available;\n      margin: 0.5rem 0.5rem\n\n  }\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContent": `styles_headerContent__cERXW`,
	"feed": `styles_feed__Q95SB`,
	"container": `styles_container__r-RE3`,
	"cardsContainer": `styles_cardsContainer__c76W8`,
	"entriesButton": `styles_entriesButton__A4zu8`,
	"dedicatedTimeFeedContainer": `styles_dedicatedTimeFeedContainer__1sRJO`
};
export default ___CSS_LOADER_EXPORT___;
